// extracted by mini-css-extract-plugin
export default {"searchBar":"SearchBar_searchBar__oRxfK","greyBackground":"SearchBar_greyBackground__PZbA-","icon":"SearchBar_icon__vqg-s"};